import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_segment_hdr_RowClass } from '../../../dbschema/bl_dgmkt_segment_hdr.model';
import { bl_dgmkt_segment_line_RowClass }from '../../../dbschema/bl_dgmkt_segment_lines.model';
import { bl_dgmkt_segment_ext_RowClass } from '../../../dbschema/bl_dgmkt_segment_exts.model'
import { bl_dgmkt_segment_event_RowClass } from '../../../dbschema/bl_dgmkt_segment_event.model';
// import {} from '../../ExtQueryCriteria'

export class DgMktSegmentContainerModel extends BaseContainerModel {
    bl_dgmkt_segment_hdr: bl_dgmkt_segment_hdr_RowClass = new bl_dgmkt_segment_hdr_RowClass();
    bl_dgmkt_segment_exts: bl_dgmkt_segment_ext_RowClass[]= [];
    bl_dgmkt_segment_lines: bl_dgmkt_segment_line_RowClass[]= [];
    // bl_dgmkt_segment_event : bl_dgmkt_segment_event_RowClass[] = []
}

/*export class SegmentContainerQueryCriteria */